import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../service/api.service';
import {HttpParams} from '@angular/common/http';
import {UntypedFormControl, UntypedFormGroup, NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import { AuthService } from 'app/service/auth.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'angly-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginFormDytron: UntypedFormGroup;
  noticiaForm: UntypedFormGroup;

  baseURL = environment.baseURL


  constructor( 
    private  api: ApiService, 
    private router: Router,
    private  auth: AuthService,
    private toastr: ToastrService,
    ) { }

  ngOnInit() {

    this.loginFormDytron = new UntypedFormGroup({
      usuario: new UntypedFormControl(''),
      password: new UntypedFormControl(''),
      // texto: new FormControl(''),
    });

    if (this.auth.isAuthenticated()) {
      this.router.navigate(['/ventana2']);
    }

  }


  login(){



    // this.api.autenticacion(form).subscribe(
    // this.api.autenticacion(form).subscribe(

    this.api.autenticacion({username: this.loginFormDytron.controls['usuario'].value , password: this.loginFormDytron.controls['password'].value}).subscribe(
    // this.api.autenticacion({usuario: "adminTrataTrafico", password: "passTrata"}).subscribe(
      resp => {
        console.log(resp);
        // this.auth.setToken(resp.token);
        this.auth.setAuth(resp.token);
        this.auth.setData(resp.datos);
        

        this.toastr.success('Acceso correcto');
        setTimeout(() => {
          this.router.navigate(['/ventana2']);
        }, 1500);


        // alert('acceso correcto')
        // this.router.navigate(['/ventana2']);
        },
      error => {
        this.toastr.error('Credenciales Erroneas'); 
      }
        // alert('credenciales erroneas ')
    );

  }





}
